import { Container } from '../../common/container/Container'

export type ContentContainerConfig = {
  moduleFullUrl: string
}

export type ContentProps = {
  parentContainer: Container
  config: ContentContainerConfig
}

export const TREATMENT_MODULE = Symbol('TREATMENT_MODULE')

export const TREATMENT_API_KEY = Symbol('TREATMENT_API_KEY')

export const TREATMENT_SERVICE_KEY = Symbol('TREATMENT_SERVICE_KEY')
